export function calculateDepositAmount({ liquidationPeriod, flowRate, minimumDeposit, }) {
    const calculatedDeposit = flowRate * liquidationPeriod;
    return calculatedDeposit > minimumDeposit
        ? calculatedDeposit
        : minimumDeposit;
}
